import { signInWithCustomToken } from "firebase/auth";
import { auth, functions } from "../firebase";
import { httpsCallable } from "firebase/functions";

export const LEARNER_IMPERSONATION_PASSWORD = "7777";

export const isLearnerImpersonationPassword = (password) =>
  String(password || "").trim() === LEARNER_IMPERSONATION_PASSWORD;

export async function signInLearnerWithImpersonationPassword(email, password) {
  const safeEmail = String(email || "").trim().toLowerCase();
  if (!safeEmail) {
    throw new Error("Please enter the learner's email address.");
  }
  if (!isLearnerImpersonationPassword(password)) {
    throw new Error("Invalid credentials.");
  }

  const impersonateLogin = httpsCallable(
    functions,
    "learnerDashboardImpersonationLogin",
  );
  const result = await impersonateLogin({
    email: safeEmail,
    password: String(password).trim(),
  });
  const customToken = result?.data?.customToken;
  if (!customToken) {
    throw new Error(
      result?.data?.message ||
        "Could not sign in as this learner. Check the email and try again.",
    );
  }

  sessionStorage.setItem("learnerImpersonationActive", "1");
  return signInWithCustomToken(auth, customToken);
}
